import { Injectable } from '@angular/core';

@Injectable()
export class DocumentService {
  noUserSelectClass = 'no-user-select';

  constructor() {
  }

  addDocumentNoUserSelectClass() {
    document.documentElement.classList.add(this.noUserSelectClass);
  }

  removeDocumentNoUserSelectClass() {
    document.documentElement.classList.remove(this.noUserSelectClass);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/document.service.ts